/**
 * PowerMeter Template Components
 * 
 * 電錶顯示 Modal Templates (只讀，無控制)
 */

import { Template01_Dashboard } from './Template01_Dashboard';

// Named exports
export { Template01_Dashboard } from './Template01_Dashboard';

// Template registry for dynamic loading
export const PowerMeterTemplates = {
  Template01: () => import('./Template01_Dashboard').then(m => m.Template01_Dashboard),
} as const;

// Default export
export default Template01_Dashboard;
